import { Center, Spinner, VStack, Text, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useUserStore } from '@store/app.store';

import NylasService from '@services/nylas.service';

export default function NylasConnectPage() {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    const handleNylasConnection = () => {
      if (!user) return;

      const nylasService = NylasService.getInstance();
      nylasService.connectNylasAccount(user);
    };

    handleNylasConnection();
  }, [user]);

  // Show loading state while processing
  return (
    <Box data-cy='nylas-connect-page'>
      <Center pt={10}>
        <VStack gap={6}>
          <Text fontSize='lg'>Connecting to Calendar...</Text>
          <Spinner size='xl' />
        </VStack>
      </Center>
    </Box>
  );
}
